<template>
  <div>
    <div class="px-5">
      <div class="text-h4 font-weight-black">Panduan Aplikasi</div>
      <div style="font-size: 10px">Last updated: April 15, 2021</div>
    </div>
    <!-- <div class="px-5 mb-5">
            <v-expansion-panels>
                <v-expansion-panel
                class="panel-accordion mt-5"
                >
                <v-expansion-panel-header class="panel-accordion font-weight-black">
                    Cara Membeli Poin Teman Bakat
                </v-expansion-panel-header>
                <v-expansion-panel-content class="py-5" style="font-size:12px;">
                    <p class="font-weight-black">Interpretation</p>
                    The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
                    <p class="font-weight-black mt-5">Definitions</p>
                    For the purposes of this Privacy Policy:
                    Account means a unique account created for You to access our Service or parts of our Service.
                    Affiliate means an entity that controls, is controlled by or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.
                    Application means the software program provided by the Company downloaded by You on any electronic device, named Teman Bakat
                    Company (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to PT Hara Anargya, Jalan PH.H. Mustofa, Surapati Core Blok C 22, Pasirlayung, Kec. Cibeunying Kidul, Kota Bandung, Jawa Barat 40192.
                    Country refers to: Indonesia
                    Device means any device that can access the Service such as a computer, a cellphone or a digital tablet.
                    Personal Data is any information that relates to an identified or identifiable individual.
                    Service refers to the Application.
                    Service Provider means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.
                    Third-party Social Media Service refers to any website or any social network website through which a User can log in or create an account to use the Service.
                    Usage Data refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).
                    You means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.
                </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel
                class="panel-accordion mt-5"
                >
                <v-expansion-panel-header class="panel-accordion font-weight-black">
                    Cara Membeli Layanan Psikotes
                </v-expansion-panel-header>
                <v-expansion-panel-content class="py-5" style="font-size:12px;">
                    <p class="font-weight-black">Interpretation</p>
                    The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
                </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel
                class="panel-accordion mt-5"
                >
                <v-expansion-panel-header class="panel-accordion font-weight-black">
                    Cara Membeli Layanan Konseling/Konsultasi
                </v-expansion-panel-header>
                <v-expansion-panel-content class="py-5" style="font-size:12px;">
                    <p class="font-weight-black">Interpretation</p>
                    The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
                </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel
                class="panel-accordion mt-5"
                >
                <v-expansion-panel-header class="panel-accordion font-weight-black">
                    Cara Mendaftar Training di Teman Bakat
                </v-expansion-panel-header>
                <v-expansion-panel-content class="py-5" style="font-size:12px;">
                    <p class="font-weight-black">Interpretation</p>
                    The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
                </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel
                class="panel-accordion mt-5"
                >
                <v-expansion-panel-header class="panel-accordion font-weight-black">
                    Cara Reedem Voucher Teman Bakat
                </v-expansion-panel-header>
                <v-expansion-panel-content class="py-5" style="font-size:12px;">
                    <p class="font-weight-black">Interpretation</p>
                    The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
                </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </div> -->
  </div>
</template>
<script>
export default {
  name: "PanduanApp",
};
</script>
<style scoped>
.panel-accordion {
  background-color: #e5e5e5;
}
</style>
